import {
  createSolidDataset,
  getSolidDataset,
  saveSolidDatasetAt,
  SolidDataset,
} from '@inrupt/solid-client'
import { logoutServer } from '../api/aggregationApi'

// const allowedAgent = 'https://podbrowser.inrupt.com/'

export const upsertSolidDataSet = async (
  { containerUri, fileName }: { containerUri: string; fileName: string },
  { fetch }: { fetch: typeof window.fetch }
): Promise<SolidDataset> => {
  const indexUrl = `${containerUri}${fileName}`
  try {
    return await getSolidDataset(indexUrl, { fetch })
  } catch (e) {
    if (e.statusCode === 404) {
      return saveSolidDatasetAt(indexUrl, createSolidDataset(), { fetch })
    } else if (e.statusCode === 401) {
      await logoutServer()
    }
    throw e
  }
}
